import { useEffect, useState } from 'react'
import { ImageCrop, ImageCropApply, ImageCropContent, ImageCropReset } from '../ui/image-crop';
import { Button } from '../ui/button';
import { X } from 'lucide-react';

type Props = {
  baseImage: string,
  aspect: number,
  onCropCancel: () => void,
  onCrop: (image: string) => void
}

export async function urlToFile(url: string, filename = 'image.jpg'): Promise<File> {
  const response = await fetch(url);
  const blob = await response.blob();
  const file = new File([blob], filename, { type: blob.type });
  return file;
}

const BaseImageCrop = ({ baseImage, onCrop, aspect, onCropCancel }: Props) => {

  const [selectedFile, setSelectedFile] = useState<File | null>(null);


  useEffect(() => {
    urlToFile(baseImage, 'remote-image.png').then(setSelectedFile);
  }, [baseImage])

  return (
    <div className="space-y-4 w-full relative">
      {selectedFile !== null &&
        <ImageCrop
          key={aspect}
          aspect={aspect}
          file={selectedFile}
          maxImageSize={10 * 1024 * 1024} // 10MB
          onCrop={onCrop}
        >
          <ImageCropContent className="max-w-2xl" />
          <div className="flex items-center gap-2">
            <ImageCropApply />
            <ImageCropReset />
            <Button
              onClick={onCropCancel}
              size="icon"
              type="button"
              variant="ghost"
            >
              <X className="size-4" />
            </Button>
          </div>
        </ImageCrop>}
    </div>
  )
}

export default BaseImageCrop;
